// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dnp-container .react-numeric-input>input{max-width:64px}`, "",{"version":3,"sources":["webpack://./src/common/components/UI/DebouncedNumericPicker/DebouncedNumericPicker.scss"],"names":[],"mappings":"AACI,0CACI,cAAA","sourcesContent":[".dnp-container{\r\n    .react-numeric-input > input {\r\n        max-width: 64px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
